/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getChronicConditions } from 'app/entities/chronic-condition/chronic-condition.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './past-medical-history.reducer';

export const PastMedicalHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const chronicConditions = useAppSelector(state => state.chronicCondition.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const pastMedicalHistoryEntity = useAppSelector(state => state.pastMedicalHistory.entity);
  const loading = useAppSelector(state => state.pastMedicalHistory.loading);
  const updating = useAppSelector(state => state.pastMedicalHistory.updating);
  const updateSuccess = useAppSelector(state => state.pastMedicalHistory.updateSuccess);

  const handleClose = () => {
    navigate(`/past-medical-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getChronicConditions({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.illnessStartDate !== undefined && typeof values.illnessStartDate !== 'number') {
      values.illnessStartDate = Number(values.illnessStartDate);
    }
    if (values.illnessEndDate !== undefined && typeof values.illnessEndDate !== 'number') {
      values.illnessEndDate = Number(values.illnessEndDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pastMedicalHistoryEntity,
      ...values,
      condition: chronicConditions.find(it => it.id.toString() === values.condition?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pastMedicalHistoryEntity,
          condition: pastMedicalHistoryEntity?.condition?.id,
          patient: pastMedicalHistoryEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pastMedicalHistory.home.createOrEditLabel" data-cy="PastMedicalHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pastMedicalHistory.home.createOrEditLabel">
              Create or edit a PastMedicalHistory
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="past-medical-history-id"
                  label={translate('tinyMedicRestApp.pastMedicalHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.illness')}
                id="past-medical-history-illness"
                name="illness"
                data-cy="illness"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.illnessDetails')}
                id="past-medical-history-illnessDetails"
                name="illnessDetails"
                data-cy="illnessDetails"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.illnessStartDate')}
                id="past-medical-history-illnessStartDate"
                name="illnessStartDate"
                data-cy="illnessStartDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.illnessEndDate')}
                id="past-medical-history-illnessEndDate"
                name="illnessEndDate"
                data-cy="illnessEndDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.active')}
                id="past-medical-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.draft')}
                id="past-medical-history-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.cursor')}
                id="past-medical-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.lastUpdated')}
                id="past-medical-history-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.microSec')}
                id="past-medical-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pastMedicalHistory.timestampEntry')}
                id="past-medical-history-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="past-medical-history-condition"
                name="condition"
                data-cy="condition"
                label={translate('tinyMedicRestApp.pastMedicalHistory.condition')}
                type="select"
              >
                <option value="" key="0" />
                {chronicConditions
                  ? chronicConditions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="past-medical-history-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.pastMedicalHistory.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/past-medical-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PastMedicalHistoryUpdate;
